export enum BranchDocumentsURL {
    AP = 'generarPresupuestoAccidentesPersonales',
    AUTOMOVILES = 'generarPresupuestoAutos',
    EFECTOS_PERSONALES = 'generarPresupuestoRiesgosVarios',
    HOGAR = 'generarPresupuestoHogar',
    INCENDIO = 'generarPresupuestoIncendio',
    INTEGRAL_COMERCIO = 'generarPresupuestoComercio',
    INTEGRAL_CONSORCIO = 'generarPresupuestoConsorcio',
    RESPONSABILIDAD_CIVIL = 'generarPresupuestoResponsabilidadCivil',
    ROBO = 'generarPresupuestoRobo',
}

export enum BudgetType {
    PRODUCTOR = 'PAS',
    CLIENTE = 'Cliente'
}

/** Coberturas (código) de rama Autos para las que no aplica franquicia de inundación en el presupuesto PDF. Deuda técnica pendiente. */
export enum CarCoverageInundacionFranchiseExempt {
    A = 'A',
    C = 'C',
}